import React from "react";
import RenderChildrenWrapper from "../RenderChildrenWrapper";
import styles from "./priorityAndIssues.module.scss";
const CLASSIFICATION_TO_UI_TEXT = {
    Goodware: "GOODWARE",
    Malicious: "MALWARE",
    Suspicious: "SUSPECT",
    Unknown: "UNKNOWN",
    "": "UNKNOWN",
};
const ClassificationLabel = ({ id, classification, componentId, componentPath, badgeWrapper, }) => {
    // Not using util function so TS can infer classification type for styles
    if (classification !== "Malicious" && classification !== "Suspicious") {
        return null;
    }
    return (React.createElement(RenderChildrenWrapper
    // Don't link if component doesn't have ID and path
    , { 
        // Don't link if component doesn't have ID and path
        wrapper: componentId && componentPath ? badgeWrapper : undefined },
        React.createElement("div", { id: id, className: styles[classification] }, CLASSIFICATION_TO_UI_TEXT[classification])));
};
export default ClassificationLabel;
//# sourceMappingURL=ClassificationLabel.js.map